import { DailySolarReport, dailySolarReportSchema } from '@sophocles/entities/DailySolarReport/dailySolarReportRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { endOfDay, format, parseISO, startOfDay } from 'date-fns';
import { fromJS } from 'immutable';
import moment from 'moment';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_DAILY_SOLAR_REPORTS = 'RECEIVE_DAILY_SOLAR_REPORTS';
function receiveDailySolarReports(json) {
  return {
    type: RECEIVE_DAILY_SOLAR_REPORTS,
    dailySolarReports: mapListToRecords(json, DailySolarReport),
  };
}

/* Request Actions */
// starter request
export const REQUEST_DAILY_SOLAR_REPORT = 'REQUEST_DAILY_SOLAR_REPORT';
function requestDailySolarReport(dailySolarReport_id) {
  return {
    type: REQUEST_DAILY_SOLAR_REPORT,
    dailySolarReport_id,
  };
}

export const REQUEST_DAILY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE = 'REQUEST_DAILY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE';
function requestDailySolarReportsForSiteWithRange(site_id, from, to) {
  return {
    type: REQUEST_DAILY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE,
    site_id,
    from,
    to,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchDailySolarReport(dailySolarReport_id) {
  return dispatch => {
    dispatch(requestDailySolarReport(dailySolarReport_id));
    return apiClient
      .get(`/dailysolarreports/${dailySolarReport_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'dailySolarReports', dailySolarReportSchema))
      .then(json => dispatch(receiveDailySolarReports(json.entities.dailySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_DAILY_SOLAR_REPORT)));
  };
}

export function fetchDailySolarReportsForSiteWithRange(site_id, from, to) {
  const fromTS = startOfDay(parseISO(from));
  const toTS = endOfDay(parseISO(to));
  return dispatch => {
    dispatch(requestDailySolarReportsForSiteWithRange(site_id, fromTS, toTS));
    return apiClient
      .get(
        `/dailysolarreports/?limit=1000&site=${site_id}&date__gte=${format(fromTS, 'yyyy-MM-dd')}&date__lte=${format(
          toTS,
          'yyyy-MM-dd',
        )}`,
      )
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'dailySolarReports', dailySolarReportSchema))
      .then(json => dispatch(receiveDailySolarReports(json.entities.dailySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_DAILY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE)));
  };
}

// expecting a siteGroup id and a moment object for endDate
export function fetchDailySolarReportsForSiteGroupWithEndDate(siteGroup_id, endDate) {
  return dispatch => {
    dispatch({ type: 'REQUEST_DAILY_SOLAR_REPORTS_FOR_SITE_GROUP_WITH_RANGE', siteGroup_id, endDate });
    return apiClient
      .get(`/dailysolarreports/?limit=1000&site__site_groups=${siteGroup_id}&date=${endDate}&exclude_wallscape=True`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_DAILY_SOLAR_REPORT)));
  };
}

/* Edit Actions */
export const EDIT_DAILY_SOLAR_REPORT = 'EDIT_DAILY_SOLAR_REPORT';
export function editDailySolarReport(dailySolarReport_id) {
  return {
    type: EDIT_DAILY_SOLAR_REPORT,
    dailySolarReport: dailySolarReport_id,
  };
}

export function patchDailySolarReport(dailySolarReport_id, values) {
  return dispatch => {
    dispatch(editDailySolarReport(dailySolarReport_id));
    return apiClient
      .patch(`/dailysolarreports/${dailySolarReport_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, dailySolarReportSchema))
      .then(json => dispatch(receiveDailySolarReports(json.entities.dailySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_DAILY_SOLAR_REPORT)));
  };
}

/* Create Actions */
export const CREATE_DAILY_SOLAR_REPORT = 'CREATE_DAILY_SOLAR_REPORT';
function sayCreateDailySolarReport(values) {
  return {
    type: CREATE_DAILY_SOLAR_REPORT,
    values: values,
  };
}

export function createDailySolarReport(values) {
  return dispatch => {
    dispatch(sayCreateDailySolarReport(values));
    return apiClient
      .post(`/dailysolarreports/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, dailySolarReportSchema))
      .then(json => dispatch(receiveDailySolarReports(json.entities.dailySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_DAILY_SOLAR_REPORT)));
  };
}

/* Delete Actions */
export const DELETE_DAILY_SOLAR_REPORT = 'DELETE_DAILY_SOLAR_REPORT';
function sayDeleteDailySolarReport(dailySolarReport_id) {
  return {
    type: DELETE_DAILY_SOLAR_REPORT,
    dailySolarReport: dailySolarReport_id,
  };
}

export function deleteDailySolarReport(dailySolarReport_id) {
  return dispatch =>
    apiClient
      .delete(`/dailysolarreports/${dailySolarReport_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteDailySolarReport(dailySolarReport_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_DAILY_SOLAR_REPORT)));
}
